import { useEffect } from 'react';

import { createOrgGroupFieldValues } from '../../utils/GroupUtils';

import validate from '@usas/ui-web/components/forms/groups/ClubSiteAttributesFormValidation';

import useOrgGroupPropertiesData from '@usas/ui-web/state/orgGroupProperties/UseOrgGroupPropertiesData';
import useGroupData from '@usas/ui-web/state/group/UseGroupData';
import useGroupCoachesData from '@usas/ui-web/state/groupCoaches/UseGroupCoachesData';
import useGroupFacilitiesData from '@usas/ui-web/state/groupFacilities/UseGroupFacilitiesData';
import useGroupFieldNamesData from '@usas/ui-web/state/groupFieldNames/UseGroupFieldNamesData';

import useForm from '@usas/ui-web/utils/UseForm';
import Constants from '@usas/ui-web/utils/Constants';

const useGroupClubSiteAttributes = () => {
  const { GROUP_CONSTANTS } = useGroupFieldNamesData();
  const { groupState, putGroup } = useGroupData();
  const { orgGroupPropertiesState, getOrgGroupProperties } = useOrgGroupPropertiesData();
  const { groupCoachesState } = useGroupCoachesData();
  const { groupFacilitiesState } = useGroupFacilitiesData();
  const { formState, errorState, onFormValueChanged, handleSubmit, setFormData, resetForm, onValueTextPairChanged
  } = useForm(getInitialFormState, submitFormCallback, validate);

  useEffect(() => {
    if (groupState.isObjLoaded === true
      && orgGroupPropertiesState.isArrayLoaded === true && orgGroupPropertiesState.groupTypeId === groupState.objData.groupTypeId
      && groupCoachesState.isArrayLoaded === true && groupCoachesState.orgUnitId === groupState.objData.orgUnitId
      && groupFacilitiesState.isArrayLoaded === true && groupFacilitiesState.orgUnitId === groupState.objData.orgUnitId) {
      const groupObj = groupState.objData;

      const facilityFieldValue = groupObj.orgGroupFieldValue.find(x => x.groupTypeField?.fieldName === GROUP_CONSTANTS.ORG_GROUP_TYPE_FIELD_NAME_FACILITY)?.fieldValue;
      const targetFacility = groupFacilitiesState.options.find(x => `${x.id}` === facilityFieldValue);

      const leadCoachFieldValue = groupObj.orgGroupFieldValue.find(x => x.groupTypeField?.fieldName === GROUP_CONSTANTS.ORG_GROUP_TYPE_FIELD_NAME_LEAD_COACH)?.fieldValue;
      const targetCoach = groupCoachesState.dataAsOptionsWithNames.find(x => `${x.id}` === leadCoachFieldValue);

      setFormData({
        ...formState,
        facilityId: targetFacility?.id || Constants.DEFAULT_ID,
        facilityName: targetFacility?.name || '--',
        leadCoachId: targetCoach?.id || '',
        leadCoachName: targetCoach?.name || '--',
        effectiveDate: groupObj.orgGroupFieldValue.find(x => x.groupTypeField?.fieldName === GROUP_CONSTANTS.ORG_GROUP_TYPE_FIELD_NAME_EFFECTIVE_DATE)?.fieldValue,
        expirationDate: groupObj.orgGroupFieldValue.find(x => x.groupTypeField?.fieldName === GROUP_CONSTANTS.ORG_GROUP_TYPE_FIELD_NAME_EXPIRATION_DATE)?.fieldValue
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgGroupPropertiesState, groupState, groupCoachesState, groupFacilitiesState]);

  useEffect(() => {
    if (groupState.isObjLoaded === true && groupState.objData.groupTypeId !== orgGroupPropertiesState.groupTypeId) {
      getOrgGroupProperties(groupState.objData.groupTypeId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupState, orgGroupPropertiesState]);

  function submitFormCallback(formState) {
    if (groupState.isObjLoading === false) {
      const newOrgGroupObj = JSON.parse(JSON.stringify(groupState.objData));

      newOrgGroupObj.orgGroupFieldValue = createOrgGroupFieldValues([
        { fieldName: GROUP_CONSTANTS.ORG_GROUP_TYPE_FIELD_NAME_EFFECTIVE_DATE, fieldValue: formState.effectiveDate },
        { fieldName: GROUP_CONSTANTS.ORG_GROUP_TYPE_FIELD_NAME_EXPIRATION_DATE, fieldValue: formState.expirationDate },
        { fieldName: GROUP_CONSTANTS.ORG_GROUP_TYPE_FIELD_NAME_FACILITY, fieldValue: formState.facilityId },
        { fieldName: GROUP_CONSTANTS.ORG_GROUP_TYPE_FIELD_NAME_LEAD_COACH, fieldValue: formState.leadCoachId }
      ], orgGroupPropertiesState.arrayData, newOrgGroupObj.orgGroupId);

      putGroup(newOrgGroupObj.orgGroupId, newOrgGroupObj);
    }
  }

  function getInitialFormState() {
    return {
      facilityId: Constants.DEFAULT_ID,
      facilityName: '--',
      leadCoachId: '',
      leadCoachName: '--',
      effectiveDate: Constants.BLANK_DATE_STRING,
      expirationDate: Constants.BLANK_DATE_STRING
    };
  }

  return {
    isSaving: groupState.isObjLoading,
    isLoading: orgGroupPropertiesState.isArrayLoading,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onValueTextPairChanged,
    onCancelClicked: resetForm,
    orgUnitId: groupState.objData.orgUnitId || ''
  };
};

export default useGroupClubSiteAttributes;